import { translation } from '../core';
import type { fr } from './fr';

export const en = translation<typeof fr>()({
  eyebrow: 'Secure payment · Stripe',
  title: 'Pre-authorise your card',
  held: 'pre-authorised, not charged',
  checking: 'Checking…',
  submit: 'Pre-authorise {amount}',
  amountToday: 'Amount pre-authorised today',
  fx: 'Your card is charged in {currency} at Cardnd’s current rate: this exact amount is held.',
  fxBalance: 'The balance at the agency is paid in MAD.',
  reassurance:
    '<b>Your card is pre-authorised, not charged.</b> It is charged when an agency confirms; otherwise the pre-authorisation is released.',
  processedBy: 'Payment processed by Stripe. Your card details never pass through Cardnd.',
  configUnavailable: 'Online payment is temporarily unavailable. Your booking is kept: try again in a moment.',
  stripeUnavailable:
    'The secure payment form could not load (payment unavailable). Check your connection, then try again: your booking is kept.',
  formUnavailable:
    'The card form could not load (payment unavailable). Close this window and try again in a moment: your booking is kept.',
  'demo.title': 'Demo mode',
  'demo.text': 'No card is asked for or charged: the Stripe form shows here with the real server.',
  'leave.eyebrow': 'Payment pending',
  'leave.title': 'Leave without paying?',
  'leave.leave': 'Leave',
  'leave.stay': 'Stay',
  'leave.text':
    'Your booking is saved but not pre-authorised yet: no agency receives it until the card is validated. You will find it for a limited time in My trips, under “To pay”.',
  noSecret: 'Online payment could not start. Your booking is kept: try again in a moment.',
  expired: 'This payment is no longer valid. Start the pre-authorisation again: your booking is kept.',
  createFailed: 'The booking could not be created. Try again in a moment.',
  'card.declined': 'Your card was declined. Try another card or contact your bank.',
  'card.insufficientFunds': 'Insufficient funds on this card. Try another card.',
  'card.expired': 'This card has expired. Use another card.',
  'card.cvc': 'The security code (CVC) is incorrect.',
  'card.number': 'The card number is incorrect.',
  'card.expiry': 'The expiry date is incorrect.',
  'card.processing': 'The bank could not process the card. Try again in a moment.',
  'card.authentication': 'Your bank’s verification (3-D Secure) did not succeed. Try again or use another card.',
  'card.invalid': 'Check the card details.',
  'card.unavailable': 'Payment temporarily unavailable. Try again in a moment.',
  'card.failed': 'The payment did not go through. Try again.',
  'status.processing': 'Your bank is still processing the payment. Wait a moment, then check My trips.',
  'status.canceled': 'This payment was cancelled. Start the pre-authorisation again.',
  'status.failed': 'The payment did not go through. Try again or use another card.',
});
